export const SUBEVENT_TOTAL_AGGREGATION = {
  cardinality: { field: 'subeventId', precision_threshold: 40_000 },
};

// The response factories drop subevents whose markets all fail quality rules, so they read up to
// three pages' worth of buckets to fill one page.
export const SUBEVENT_OVERFETCH_FACTOR = 3;

// InstantSearch's disjunctive facet requests arrive with hitsPerPage 0 and no `type`, so they can reach
// a query factory too; ES rejects a terms size of 0.
export function getSubeventBucketSize(params: { hitsPerPage: number; isWalled?: boolean; page: number }) {
  // A walled response is sliced to a single hit in `utils/response-utils.ts`, so buckets beyond the
  // first surviving subevent can never be rendered. The slice stays the enforcement point; this only
  // stops ES computing what nobody can see.
  if (params.isWalled) {
    return SUBEVENT_OVERFETCH_FACTOR;
  }

  return Math.max(1, (params.page + 1) * params.hitsPerPage * SUBEVENT_OVERFETCH_FACTOR);
}
